<template>
  <click-to-edit
    v-model="weight_rounded"
    :disabled="!isFieldAvailableForEdit(scope.row, 'weight')"
    placeholder=""
    digits-only
    @input="saveElementPropChange(scope.row, 'weight')"
  ></click-to-edit>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
export default {
  name: 'astra-top-element-weight-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  computed: {
    weight_rounded: {
      get() {
        return Math.round(this.scope.row.weight);
      },
      set(val) {
        this.scope.row.weight = val;
      }
    }
  },

  props: {},
  data() {
    return {

    }
  },
  methods: {}
}

</script>

<style>

</style>
